/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DisconnectedEntityLicenseOfferResponse { 
    subscribed_quantity?: number;
    subscription_expiry?: Date;
    used_quantity?: number;
}

